import * as FileSaver from "file-saver";
import XLSX from "sheetjs-style";
import { baseURL } from "./axios-utils";
import secureLocalStorage from "react-secure-storage";
import { toast } from "react-toastify";

const fileType =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset-UTf-8";
const fileExtention = ".xlsx";

export const exportToExcel = (data, filename) => {
  const ws = XLSX.utils.json_to_sheet(data);
  const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
  const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  const excelData = new Blob([excelBuffer], { type: fileType });
  FileSaver.saveAs(excelData, filename + fileExtention);
};

export const viewDocument = (
  fileUrl,
  method = "GET",
) => {

  // const a = document.createElement("a");
  // a.href = fileUrl;
  // a.target = "_blank"; // Open in a new tab
  // a.click();

  fetch(fileUrl, {
    method,
  })
    .then((res) => {
      // console.log(res)
      return res.blob();
    })
    .then((str) => {
      var url = window.URL || window.webkitURL;
      var link = url.createObjectURL(str);
      var a = document.createElement("a");
      a.setAttribute(
        "target",
        "_blank"
      );
      a.setAttribute("href", link);
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(link);
    })
    .catch((err) => {
      toast.error("Error downloading file, please check your network and try again ")
      console.log(err);
    });

}

/*
export const downloadOnClick = (
  fileUrl,
  fileName,
  method = "GET",
  data = {},
  cb = (res) => {}
) => {
  if (!fileUrl || !fileName) return;

  const userData = secureLocalStorage.getItem("hms_user");
  let auth = null;
  if (userData) {
    const { token } = userData;
    auth = `Bearer ${token}`;
  }

  fetch(fileUrl, {
    method,
    body: method !== "GET" ? JSON.stringify(data) : null,
    headers: {
      "Content-Type": "application/json",
      Authorization: auth,
    },
  })
    .then((res) => {
      return res.blob();
    })
    .then((str) => {
      var url = window.URL || window.webkitURL;
      var link = url.createObjectURL(str);
      var a = document.createElement("a");
      a.setAttribute(
        "download",
        `${fileName || "downloaded at" + new Date().getTime()}`
      );
      a.setAttribute("href", link);
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(link);
      cb(true);
    })
    .catch((err) => {
      cb(false);
      console.log(err);
    });
};
*/

export const downloadOnClick = (
  fileUrl,
  fileName,
  method = "GET",
  data = {},
  cb = (res) => {}
) => {
  if (!fileUrl || !fileName) return;

  const userData = secureLocalStorage.getItem("hms_user");
  let auth = null;
  if (userData) {
    const { token } = userData;
    auth = `Bearer ${token}`;
  }

  // --- LOGIC CHANGE START ---
  // Check if the URL is an external S3 link or an internal API link
  const isExternal = fileUrl.includes("amazonaws.com") || fileUrl.includes("cloudinary");

  const headers = {
    "Content-Type": "application/json",
  };

  // ONLY add Authorization if it's NOT an external S3 link
  if (auth && !isExternal) {
    headers["Authorization"] = auth;
  }
  // --- LOGIC CHANGE END ---

  fetch(fileUrl, {
    method,
    body: method !== "GET" ? JSON.stringify(data) : null,
    headers: headers,
  })
    .then((res) => {
      // IMPORTANT: Check if the request actually succeeded
      if (!res.ok) {
        throw new Error(`Server returned ${res.status}: ${res.statusText}`);
      }
      return res.blob();
    })
    .then((blob) => {
      var url = window.URL || window.webkitURL;
      var link = url.createObjectURL(blob);
      var a = document.createElement("a");
      
      // Ensure file extension is correct
      const finalFileName = fileName.toLowerCase().endsWith('.pdf') 
        ? fileName 
        : `${fileName}.pdf`;

      a.setAttribute("download", finalFileName);
      a.setAttribute("href", link);
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(link);
      cb(true);
    })
    .catch((err) => {
      cb(false);
      console.error("Download Error:", err);
      // Optional: alert the user that the download failed
      alert("Could not download file. The link may have expired or permissions are restricted.");
    });
};